import axios from '../axios'
// 创建工资条

// 获取头部获取企业列表-查询
export const findCompanyInfoList = () => {
  return axios({
    url: '/CompanySalaryOrder/findCompanyInfoList',
    method: 'get'
  })
};

// 获取该人员的所负责的企业
export const findCompanyList = (data) => {
  return axios({
      url: '/CompanySalaryOrder/findCompanysByCyhrAccountId',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data'},
      data
  })
};

// 上传文件
export const upLoad = (data) => {
  return axios({
    url: '/salaryOrderUploadExcel/uploadExcel',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data'},
    data
  })
};

// 核对数据
export const salaryOrder = data => {
  return axios({
    url: '/CompanySalaryOrder/findSalaryOrderDetail',
    method: 'post',
    data
  })
};

// 第三步下拉选项
export const salarySelect = data => {
  return axios({
    url: '/tCyCompanySalaryOrderHead/findSalaryOrderHeads',
    headers: { 'Content-Type': 'multipart/form-data'},
    method: 'post',
    data
  })
};

// 发送
export const submitSalary = data => {
  return axios({
    url: '/salaryOrderUploadExcel/postSalaryExcel',
    method: 'post',
    data
  })
}

// 查询本企业薪资列表！
export const findCompanySalaryType = (params) => {
    return axios({
        url: '/tCyCompanySalaryType/findCompanySalaryTypes.html',
        method: 'get',
        params
    })
};

// 新添加企业自定义薪资类型
export const addCompanySalaryType = data => {
    return axios({
        url: '/tCyCompanySalaryType/addCompanySalaryType.html',
        method: 'post',
        data
    })
};

// 删除企业自定义薪资类型
export const delCompanySalaryType = (params) => {
    return axios({
        url: '/tCyCompanySalaryType/deleteCompanySalaryType.html',
        method: 'get',
        params
    })
};

// 修改企业自定义薪资类型！
export const updateCompanySalaryType = data => {
    return axios({
        url: '/tCyCompanySalaryType/updateCompanySalaryType.html',
        method: 'post',
        data
    })
};




// WEBPACK FOOTER //
// ./src/http/moudules/found.js